export default "__VITE_ASSET__DjYflket__ 320w, __VITE_ASSET__bPJXOe2Y__ 480w, __VITE_ASSET__BT2pp9Wx__ 640w, __VITE_ASSET__BXFqjFfX__ 800w";